import React, { useEffect, useState } from 'react';
import { getDataFromFirebase } from '../Config/commonFirebaseImage';
import { Skeleton } from '@mui/material';

const VideoComponent = ({width, height, path, thumbnilPath, thumbnilURL="", url=""}) => {
    const [firebaseURL, setFirebaseURL] = useState(url)
    const [loading, setLoading] = useState(true)
    const [firebaseThumbnialURL, setFirebaseThumbnialURL] = useState(thumbnilURL)

    const getURL= async(path)=>{
        return await getDataFromFirebase(path) || ""
    }

    const setURLs = async()=>{
        if(path){
            setFirebaseURL(await getURL(path))
        }
        if(thumbnilPath){
            setFirebaseThumbnialURL(await getURL(thumbnilPath))
        }
        setLoading(false)
    }

    useEffect(()=>{
        if(path){
            setURLs()
        }else{
            setLoading(false)
        }
    }, [path])

  return (
    <>
    {
        loading ? <Skeleton variant="rounded" className='my-2' width={width || 600} height={height || 240} />
        :
        firebaseURL ?
        <video className="videoShow" poster={firebaseThumbnialURL} width={width || "600" } height={height || "240"} controls>
            <source src={firebaseURL} type="video/mp4" />
        </video>:
        <div className='noVideoDiv'>
            <p className='textNoVideo'>Video not uploaded</p>
        </div>
    }
    </>
  )
}

export default VideoComponent;